// extracted by mini-css-extract-plugin
export default {"about":"about_about__N9c+5","wrapper":"about_wrapper__Rptpx","column":"about_column__xKfkP","socialMediaWrapper":"about_socialMediaWrapper__ZIOZa"};